import { Component, OnInit } from '@angular/core';
import { BookstoreService } from 'src/app/services/bookstore/bookstore.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-package-setup',
  templateUrl: './package-setup.component.html',
  styleUrls: ['./package-setup.component.css']
})
export class PackageSetupComponent implements OnInit {

  ItemList: any;
  Submitted: boolean = false;
  ItemMsg: any;
  AlertSave: any;
  AlertPakage: any;
  ClassList: any;
  ItemCategoryList: any;
  OneTimePackageList: any;
  ItemMasterList: any;


  constructor(private bookstoreservice: BookstoreService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  OneTimePackageSetupModel = {

    ItemCategoryID: 0,
    ClassID: 0,
    ItemID: 0,
    ItemName: '',
    Qty: 0,
    UnitPrice: 0,
    Remarks: '',
    AvailableQty: 0,
    PackageID: 0,
    PackageName: '',

  }

  Clear() {
    this.OneTimePackageSetupModel.ClassID = 0;
    this.OneTimePackageSetupModel.ItemID = 0;
    this.OneTimePackageSetupModel.ItemName = '';
    this.OneTimePackageSetupModel.PackageName = '';
    this.OneTimePackageSetupModel.Remarks = '';
    this.OneTimePackageSetupModel.UnitPrice = 0;
    this.OneTimePackageSetupModel.Qty = 0;
    this.OneTimePackageSetupModel.PackageID=0;
    this.ItemList = [];
    this.OneTimePackageSetupModel.ItemCategoryID = 0;
    this.Submitted = false;
    this.ItemMsg = '';
  };


  // Package Details

  GetAllOneTimePackageSetup() {
    this.OneTimePackageSetupModel.PackageID=0;
    this.OneTimePackageSetupModel.PackageName='';
    this.spinnerService.show();
    var List = {
      ClassID: this.OneTimePackageSetupModel.ClassID,
    };
    this.bookstoreservice.GetAllOneTimePackageSetup(JSON.stringify(List)).subscribe((data: any) => {
      this.OneTimePackageList = data.OneTimePackageList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
      this.ItemList = [];
    });
  };


  SaveOneTimePackage() {
    this.AlertPakage = '';
    for (var i = 0; i < this.OneTimePackageList.length; i++) {
      if (this.OneTimePackageList[i].PackageID != this.OneTimePackageSetupModel.PackageID && this.OneTimePackageList[i].PackageName == this.OneTimePackageSetupModel.PackageName) {
        this.AlertPakage = ' Package Name Already Exists';
        return false;
      }
    }
    this.AlertSave = '';
    if (this.ItemList.length > 0) {
      this.spinnerService.show();
      this.bookstoreservice.SaveOneTimePackage(JSON.stringify(this.OneTimePackageSetupModel), JSON.stringify(this.ItemList)).subscribe((data: any) => {
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
        if (data.webResponse.Status && this.OneTimePackageSetupModel.PackageID==0) {
          this.GetAllOneTimePackageSetup();
          this.Clear();
        }


      });
    }
    else {
      this.AlertSave = ' Please Add Item ';
    }
  };

  GetClassItemList(obj) {
    this.OneTimePackageSetupModel.PackageID = obj.PackageID;
    this.OneTimePackageSetupModel.PackageName = obj.PackageName;
    this.OneTimePackageSetupModel.ClassID = obj.ClassID;
    this.ItemList = obj.OneTimeList;

  };

  ngOnInit() {
    this.BindClass();
    this.GetItemCategory();
  }

  BindClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  };

  GetItemCategory() {
    var item = {
      ItemId: 2
    }
    this.lookupservice.GetLookupsList('StockInventoryItemCategory', JSON.stringify(item)).subscribe((data: any) => {
      this.ItemCategoryList = data.LookupItems;
    });
  };

  GetAllItem() {
    var itembo = {
      'ItemId': this.OneTimePackageSetupModel.ItemCategoryID,
      'ItemId1': 2,
    }
    this.lookupservice.GetLookupsList('ItemMaster', JSON.stringify(itembo)).subscribe((data: any) => {
      this.ItemMasterList = data.LookupItems;
    });
  };

  GetSellingPrice() {
    for (var i = 0; i < this.ItemMasterList.length; i++) {
      if (this.ItemMasterList[i].ItemId == this.OneTimePackageSetupModel.ItemID) {
        this.OneTimePackageSetupModel.UnitPrice = this.ItemMasterList[i].SellingPrice;
      }
    }
  }

  Validate() {
    return this.OneTimePackageSetupModel.ItemID == 0 || this.OneTimePackageSetupModel.ItemCategoryID == 0;
  };
  GetItemName(ItemID) {
    for (var i = 0; i < this.ItemMasterList.length; i++) {
      if (this.ItemMasterList[i].ItemId == ItemID) {
        return this.ItemMasterList[i].ItemName;
      }
    }
  }

  GetItemCtegory(ItemCategoryID) {
    for (var i = 0; i < this.ItemCategoryList.length; i++) {
      if (this.ItemCategoryList[i].ItemId == ItemCategoryID) {
        return this.ItemCategoryList[i].ItemName;
      }
    }
  }


  Add(valid) {
    this.ItemMsg = "";
    this.AlertSave = '';
    for (var i = 0; i < this.ItemList.length; i++) {
      if (this.ItemList[i].ItemID == this.OneTimePackageSetupModel.ItemID) {
        this.ItemMsg = 'Item is already exist';
        return;
      }
    }

    this.Submitted = true;
    if (valid && !this.Validate()) {
      var item = {
        ItemName: this.GetItemName(this.OneTimePackageSetupModel.ItemID),
        ItemID: this.OneTimePackageSetupModel.ItemID,
        Qty: this.OneTimePackageSetupModel.Qty,
        UnitPrice: this.OneTimePackageSetupModel.UnitPrice,
        ItemCategory: this.GetItemCtegory(this.OneTimePackageSetupModel.ItemCategoryID),
      };
      this.ItemList.push(item);

    }

  }
  removeRow(index) {
    this.ItemList.splice(index, 1);

  };


  // Print

  PrintPage(item) {
    var url = "packageprint?PackageID=" + item.PackageID ;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
    
}


}
